/* React base class */
import { Component } from "react"

/* Redux store connection */
import { connect } from "react-redux"

/* Router HOC */
import { withRouter, applySeo } from "../../helpers"

/* Shared UI components */
import { Account, Loading, Network } from "../../components"

/* Icon component */
import Icon from "../../components/Icon"

/* Notification API: list, mark one/all as read */
import { list, read, readAll } from "../../api/Notification"

/* i18n */
import { translate } from "../../translates"

/* Icon per notification tone (colours live in notifications.css) */
const TONE_ICONS = {
    success: "check",
    accent: "star",
    warn: "clock",
    danger: "heart",
    info: "bell"
}

/* Page Notifications */
class Notifications extends Component {

    constructor(props) {
        super(props)

        /* State */
        this.state = {
            loading: true,
            error: false,
            items: []
        }
    }

    componentDidMount = () => {

        /* SEO */
        applySeo({ title: `Уведомления — Bookify`, description: `Ваши уведомления в Bookify.`, path: `/notifications`, robots: `noindex, nofollow` })

        /* Scroll */
        window.scroll(0, 0)

        /* Load */
        this.load()
    }

    /* Draw Load */
    load = () => {

        /* Fields */
        const { token } = this.props

        /* Fetch notifications */
        this.setState({ loading: true, error: false })
        list(token).then((response) => {
            if (response && response.status === 200) {
                this.setState({ items: Array.isArray(response.data) ? response.data : [], loading: false })
            }
            else {
                this.setState({ loading: false, error: true })
            }
        })
    }

    /* Draw Read All */
    _readAll = () => {

        /* Fields */
        const { items } = this.state
        const { token } = this.props

        /* Mark everything as read */
        readAll(token).then(() => {
            this.setState({ items: items.map((item) => ({ ...item, read: true })) })
        })
    }

    /* Draw Read */
    _read = (id) => {

        /* Fields */
        const { items } = this.state
        const { token } = this.props

        /* Mark a single notification as read */
        read(token, id)
        this.setState({ items: items.map((item) => (item.id === id ? { ...item, read: true } : item)) })
    }

    /* Draw Item */
    _item = (notification) => {

        /* Fields */
        const tone = TONE_ICONS[notification.tone] ? notification.tone : "info"

        return (
            <button key={`${notification.id}`} className={`notifications__item${notification.read ? "" : " notifications__item--unread"}`} onClick={() => this._read(notification.id)}>
                <span className={`notifications__icon notifications__icon--${tone}`}>
                    <Icon name={TONE_ICONS[tone]} size={18} />
                </span>
                <span className="notifications__body">
                    <span className="notifications__title">{notification.title}</span>
                    <span className="notifications__text">{notification.text}</span>
                </span>
                {!notification.read && <span className="notifications__dot" />}
            </button>
        )
    }

    /* Draw Content */
    _content = () => {

        /* Fields */
        const { loading, error, items } = this.state

        /* Loading */
        if (loading) {
            return <Loading inline />
        }

        /* Error */
        if (error) {
            return <Network onRetry={this.load} />
        }

        /* Empty */
        if (items.length === 0) {
            return (
                <div className="empty">
                    <div className="empty__art"><Icon name="bell" size={48} /></div>
                    <h3>{translate("Уведомлений пока нет")}</h3>
                    <p>{translate("Здесь появятся записи, напоминания и предложения.")}</p>
                </div>
            )
        }

        /* List */
        return (
            <div className="notifications__list">
                {items.map((notification) => this._item(notification))}
            </div>
        )
    }

    render = () => {
        return (
            <Account active="notifications">
                <div className="content">
                    <div className="notifications__head">
                        <div>
                            <h2 className="content__title">{translate("Уведомления")}</h2>
                            <p className="content__subtitle notifications__subtitle">{translate("Записи, напоминания и предложения")}</p>
                        </div>
                        <button className="btn btn--ghost notifications__read-all" onClick={this._readAll}>
                            <Icon name="check" size={14} /> {translate("Прочитать все")}
                        </button>
                    </div>

                    {this._content()}
                </div>
            </Account>
        )
    }
}

/* Map State To Props */
const mapStateToProps = state => {
    return {
        token: state.token,
        lang: state.lang
    }
}

/* Export */
export default connect(mapStateToProps)(withRouter(Notifications))
